import {Message} from '../model/byMatch';
import {isLocalMessage} from './isLocalMessageId';

export type MessageKey = `msg${number}-${string}`;

export function buildMessageKey(
  matchId: number,
  messageId: number | string
): MessageKey {
  return `msg${matchId}-${String(messageId)}`;
}

export function getMessageKey(message: Message): MessageKey {
  const matchId = message.match_id ?? 0;
  if (isLocalMessage(message) && message.clientId) {
    return buildMessageKey(matchId, message.clientId);
  }

  return buildMessageKey(matchId, message.id);
}
